<template>
  <div>
    <div class="relative flex gap-3 justify-between md:block md:gap-0 md:items-center items-start">
      <div>
        <div class="w-[90px] md:w-full relative">
          <div class="w-full flex justify-center relative">
            <img v-if="usuario.urlImagen" :src="usuario.urlImagen + '?t=' + new Date().getTime()" alt="" class="
              w-full object-cover rounded" />
            <!-- Sino mostrar placeholder -->
            <div v-else
              class="w-full h-full bg-slate-100 flex justify-center items-center rounded min-w-[90px] min-h-[270px]">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
              </svg>
            </div>
          </div>

          <!-- Boton absolute para cambiar la imagen -->
          <div class="absolute bottom-0 right-0">
            <button @click="$refs.fileInput.click()"
              class="flex items-center gap-1 bg-blue-500 text-white !text-xs md:text-xs font-medium px-2 py-1 rounded md:m-4 m-2">
              <span class="hidden md:inline">Cambiar</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-3">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
              </svg>

            </button>
            <input type="file" class="hidden" ref="fileInput" @change="uploadImage" />
          </div>

        </div>
      </div>
      <div class=" md:flex justify-between items-center md:mt-4" v-if-off="!hideName">
        <h2 class="text-xl text-black font-semibold">
          {{ usuario.nombre }} {{ usuario.apellido }}
        </h2>
      </div>

      <!-- Texto para mostrar y ocultar información -->
      <div @click="toggleInfo" class="flex justify-between items-center md:mt-4 absolute bottom-0 right-0 md:hidden">
        <div class="flex items-center gap-1">
          <svg v-if="!mostrarInfo" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" class="w-3 h-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
            class="w-3 h-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
          </svg>
          <p class="text-black text-xs md:text-xs font-medium text-blue-500 uppercase">
            {{ mostrarInfo ? "Ocultar detalles" : "Mostrar detalles" }}
          </p>
        </div>
      </div>

    </div>

    <!-- Información configurable -->
    <div v-if="liveConfig && liveConfig.length > 0" class="mt-4" :class="{ 'hidden md:block': !mostrarInfo }">
      <div v-for="(field, index) in liveConfig" :key="index">
        <div v-if="getUsuarioData(field.key) || field.key === 'idSocio'"
          class="flex justify-between items-center py-2 border-b border-slate-200">
          <p class="text-black text-xs md:text-xs uppercase">{{ field.label }}</p>
          <div class="text-black text-xs md:text-xs">
            <div class="font-semibold uppercase w-full overflow-ellipsis max-w-[250px]">
              {{ getUsuarioData(field.key) }} </div>



            <div v-if="field.key === 'idSocio' && !usuario.idSocio" class="tooltip tooltip-right"
              data-tip="Completa tu perfil para recibir un número de socio">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-5 text-gray-600">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Boton para editar el perfil -->
    <div class="flex justify-center mt-4" v-if="!estaEnPerfil">
      <router-link to="/perfil/"
        class="w-full bg-blue-500 text-center text-white !text-xs md:text-xs font-medium px-2 py-1 rounded">
        Editar mi perfil
      </router-link>
    </div>

  </div>
</template>

<script>
import { miUsuario, avatar } from "@/services/usuarios";
import { faker } from "@faker-js/faker";

export default {
  name: "Perfil",
  props: {
    config: {
      type: Array,
      default: () => [],
    },
    hideName: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      usuario: {},
      defaultConfig: [
        { label: "Socio N°", key: "idSocio" },
        { label: "Email", key: "email" },
        { label: "Teléfono", key: "telefono" },
        { label: "Provincia", key: "provincia" },
        { label: "País", key: "pais" },
      ],
      mostrarInfo: false,
    };
  },
  async mounted() {
    const user = await miUsuario();
    if (!user || Object.keys(user).length === 0) {
      this.generarUsuarioFalso();
      console.warn("No se pudo obtener el usuario", this.usuario);
    } else {
      this.usuario = user;
    }
  },
  computed: {
    estaEnPerfil() {
      return this.$route.path === "/perfil";
    },
    liveConfig() {
      return this.config.length > 0 ? this.config : this.defaultConfig;
    }
  },
  methods: {
    toggleInfo() {
      this.mostrarInfo = !this.mostrarInfo;
    },
    generarUsuarioFalso() {
      this.usuario = {
        nombre: faker.name.firstName(),
        apellido: faker.name.lastName(),
        email: faker.internet.email(),
        telefono: faker.phone.number({ style: "international" }),
        provincia: faker.address.state(),
        pais: faker.address.country(),
        urlImagen: faker.image.avatar(),
        idSocio: faker.number.int({ min: 100000, max: 999999 }),
      };
    },
    // Devuelve el valor correspondiente al campo del usuario
    getUsuarioData(key) {
      // Si es idSocio y existe, formatear miles con punto
      if (key === "idSocio" && this.usuario.idSocio) {
        return this.usuario.idSocio.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }


      return this.usuario[key] || null;
    },
    uploadImage(e) {
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      avatar(formData).then((res) => {
        console.log(res);
        this.usuario.urlImagen = res.url + "?t=" + new Date().getTime();
      });
    },
  }
};
</script>
<style>
.overflow-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>